import { useSelector } from 'react-redux';

export const useTranslations = () => {
  const translations = useSelector(state => state.config.Translations);

  const translate = (key, params) => {
    if (!translations || !key) {
      return key || '';
    }
    let translation = translations[key] || key;
    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        translation = translation.replace(`{${key}}`, value);
      });
    }
    return translation;
  };

  return {
    translate,
    translations,
  };
};

